import { default as bluescribeXSPykMnOAEMeta } from "/vercel/path0/pages/battlescribe/bluescribe.vue?macro=true";
import { default as fancyscribeYzIO8FEGlXMeta } from "/vercel/path0/pages/battlescribe/fancyscribe.vue?macro=true";
import { default as libraryMDvES2IWXvMeta } from "/vercel/path0/pages/battlescribe/library.vue?macro=true";
import { default as indexe9Brt5DfdhMeta } from "/vercel/path0/pages/index.vue?macro=true";
import { default as indexOGEc77DWu7Meta } from "/vercel/path0/pages/lists/[list]/index.vue?macro=true";
import { default as _91unit_93vyDd3AZGCcMeta } from "/vercel/path0/pages/lists/[list]/units/[unit].vue?macro=true";
import { default as indexEr8dhkfcN6Meta } from "/vercel/path0/pages/lists/index.vue?macro=true";
import { default as mathhammersZCBX1KwaqMeta } from "/vercel/path0/pages/mathhammer.vue?macro=true";
import { default as indexS1Y0mOtI4KMeta } from "/vercel/path0/pages/resources/index.vue?macro=true";
export default [
  {
    name: bluescribeXSPykMnOAEMeta?.name ?? "battlescribe-bluescribe",
    path: bluescribeXSPykMnOAEMeta?.path ?? "/battlescribe/bluescribe",
    meta: bluescribeXSPykMnOAEMeta || {},
    alias: bluescribeXSPykMnOAEMeta?.alias || [],
    redirect: bluescribeXSPykMnOAEMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/battlescribe/bluescribe.vue").then(m => m.default || m)
  },
  {
    name: fancyscribeYzIO8FEGlXMeta?.name ?? "battlescribe-fancyscribe",
    path: fancyscribeYzIO8FEGlXMeta?.path ?? "/battlescribe/fancyscribe",
    meta: fancyscribeYzIO8FEGlXMeta || {},
    alias: fancyscribeYzIO8FEGlXMeta?.alias || [],
    redirect: fancyscribeYzIO8FEGlXMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/battlescribe/fancyscribe.vue").then(m => m.default || m)
  },
  {
    name: libraryMDvES2IWXvMeta?.name ?? "battlescribe-library",
    path: libraryMDvES2IWXvMeta?.path ?? "/battlescribe/library",
    meta: libraryMDvES2IWXvMeta || {},
    alias: libraryMDvES2IWXvMeta?.alias || [],
    redirect: libraryMDvES2IWXvMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/battlescribe/library.vue").then(m => m.default || m)
  },
  {
    name: indexe9Brt5DfdhMeta?.name ?? "index",
    path: indexe9Brt5DfdhMeta?.path ?? "/",
    meta: indexe9Brt5DfdhMeta || {},
    alias: indexe9Brt5DfdhMeta?.alias || [],
    redirect: indexe9Brt5DfdhMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexOGEc77DWu7Meta?.name ?? "lists-list",
    path: indexOGEc77DWu7Meta?.path ?? "/lists/:list()",
    meta: indexOGEc77DWu7Meta || {},
    alias: indexOGEc77DWu7Meta?.alias || [],
    redirect: indexOGEc77DWu7Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/lists/[list]/index.vue").then(m => m.default || m)
  },
  {
    name: _91unit_93vyDd3AZGCcMeta?.name ?? "lists-list-units-unit",
    path: _91unit_93vyDd3AZGCcMeta?.path ?? "/lists/:list()/units/:unit()",
    meta: _91unit_93vyDd3AZGCcMeta || {},
    alias: _91unit_93vyDd3AZGCcMeta?.alias || [],
    redirect: _91unit_93vyDd3AZGCcMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/lists/[list]/units/[unit].vue").then(m => m.default || m)
  },
  {
    name: indexEr8dhkfcN6Meta?.name ?? "lists",
    path: indexEr8dhkfcN6Meta?.path ?? "/lists",
    meta: indexEr8dhkfcN6Meta || {},
    alias: indexEr8dhkfcN6Meta?.alias || [],
    redirect: indexEr8dhkfcN6Meta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/lists/index.vue").then(m => m.default || m)
  },
  {
    name: mathhammersZCBX1KwaqMeta?.name ?? "mathhammer",
    path: mathhammersZCBX1KwaqMeta?.path ?? "/mathhammer",
    meta: mathhammersZCBX1KwaqMeta || {},
    alias: mathhammersZCBX1KwaqMeta?.alias || [],
    redirect: mathhammersZCBX1KwaqMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/mathhammer.vue").then(m => m.default || m)
  },
  {
    name: indexS1Y0mOtI4KMeta?.name ?? "resources",
    path: indexS1Y0mOtI4KMeta?.path ?? "/resources",
    meta: indexS1Y0mOtI4KMeta || {},
    alias: indexS1Y0mOtI4KMeta?.alias || [],
    redirect: indexS1Y0mOtI4KMeta?.redirect || undefined,
    component: () => import("/vercel/path0/pages/resources/index.vue").then(m => m.default || m)
  }
]